import { render, staticRenderFns } from "./GenerateOrderKwu.vue?vue&type=template&id=66f728b4&"
import script from "./GenerateOrderKwu.vue?vue&type=script&lang=js&"
export * from "./GenerateOrderKwu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports